import chartsChart from '../charts/charts.js';
import technicals from './technicals.js';

export default function(res, target, data) {
	technicals(res, target, data, 'charts', chartsChart);
}
